<template>
<ContenedorCampos :titulo="titulo" :isObligatorio="Obligatorio" :error="error">
  <v-select
    :disabled="bDeshabilitado"
    label="Seleccione un elemento"
    v-model="selectValue"
    :items="aDatoMostrar"
    item-text="DatoMostrar"
    item-value="ID"
    @change="Change"
    :loading="bCargando"
    autocomplete
    clearable
    dense
    outlined
    hide-details
    >
  </v-select>
</ContenedorCampos>
</template>
<script>
import ContenedorCampos from '@/components/dinamicos/ContenedorCampos.vue'
import DinamicosMixin from '@/mixins/dinamicosMixin.js'

import { mapGetters } from 'vuex'

export default {
  name: 'Select',
  mixins: [ DinamicosMixin ],  
  components: {
    ContenedorCampos,
  },
  data () {
    return {
    }
  },
  async mounted () {
    await this.CargarData()

  },
  methods: {
    Change (){
    },
  },
  computed: {
    aDatoMostrar(){

      // valido si en getaModificaA existe algo del id de este select para filtar sino regresa la variable limpia.
      if((this.getnModificaA > 0) && (this.getaModificaA[this.id] !== undefined) && (this.getaModificaA[this.id] !== null) && (this.getaModificaA[this.id] !== "") ){
        return this.aOptions.filter( elemento => elemento.Filtro == this.getaModificaA[this.id] ) 
      } 

      return this.aOptions
    },

    ...mapGetters('dinamicos',['getaModificaA', 'getnModificaA'])
  },

}
</script>

<style lang="scss" scoped>

</style>
